import { Component } from '@opten/compiler/metadata/component';

@Component({ className: 'js-form-total' })
export class FormTotalComponent {
	private inputs: HTMLInputElement[];

	constructor(private total: HTMLElement) {
		const form = total.closest('form') as HTMLElement; 
		this.inputs = Array.from(
			form.querySelectorAll(
				`[data-group="${this.total.getAttribute('data-group')}"]`
			)
		) as HTMLInputElement[];
		if (this.inputs && this.inputs.length > 0) {
			this.inputs.forEach((input) => {
				input.addEventListener('change', () => this.updateTotal());
				input.addEventListener('input', () => this.updateTotal());
			});
			this.updateTotal();
		}
	}

	private updateTotal() {
		let total = 0;
		this.inputs.forEach((input) => {
			const factor = parseFloat(input.getAttribute('data-factor') || '1');
			total += factor * parseInt(input.value || '0');
		});
		this.total.innerHTML = total.toString();
	}
}
